export enum eBooleanChoices {
    True = 1,
    False = 0
} 